import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { useWindowSize } from "react-use";
gsap.registerPlugin(ScrollToPlugin);

const FounderPersonNew = ({ founder, reverse, id, customCss }) => {
  const { width } = useWindowSize();
  const [readmore, setReadMore] = useState(false);
  const [navbarHeight, setNavbarHeight] = useState(0);
  const contentRef = useRef(null);

  const handleReadMore = () => {
    if (readmore) {
      setReadMore(false);

      const dynamicOffset =
        width >= 2560 ? 100 : width >= 1920 ? 70 : width >= 1536 ? 50 : 0;
      const { height } = document
        ?.querySelector(".navbar")
        .getBoundingClientRect();

      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: contentRef.current,
          offsetY: height + dynamicOffset,
        },
        ease: "power2.out",
      });
    } else {
      setReadMore(true);
    }
  };

  return (
    <div
      data-aos="fade-up"
      className="grid grid-cols-1 gap-6 xl:grid-cols-2 md:gap-8"
      ref={contentRef}
    >
      <div className="font-montserrat font-light text-[16px] md:text-[18px] 3xl-plus:text-[24px] text-white">
        <p dangerouslySetInnerHTML={{ __html: founder?.descToShow }}></p>

        {readmore && (
          <>
            <br />
            <p dangerouslySetInnerHTML={{ __html: founder?.readMore }}></p>
          </>
        )}

        <br />
        <span className="underline cursor-pointer" onClick={handleReadMore}>
          {readmore ? "READ LESS" : "READ MORE"}
        </span>
      </div>
      <div
        className={`relative ${
          reverse ? "order-[-1]" : "order-[-1] xl:order-none"
        }`}
      >
        <div
          className={`relative w-full mx-auto ${
            readmore
              ? "h-full md:h-[60vh] xl:h-[80vh] xl:sticky xl:top-[15vh] 3xl-plus:top-[10vh] 3xl-plus:h-[90vh]"
              : "h-full md:h-[60vh] xl:h-full xl:absolute xl:left-1/2 xl:-translate-x-1/2"
          }`}
        >
          <div className="h-full w-fit relative mx-auto">
            <img
              src={founder?.image}
              alt={`${founder?.firstName} ${founder?.lastName}`}
              // height={833}
              // width={554}
              // className={`h-full object-contain object-bottom ${
              //   readmore ? "" : "sm:scale-105 2xl:scale-[1.20] 3xl:scale-[1.3]"
              // }`}
              // className={`h-full object-contain object-bottom ${
              //   readmore
              //     ? ""
              //     : `${
              //         id === 0
              //           ? "tab:scale-110 xl:scale-[1.3] 3xl-plus:scale-[1.4]"
              //           : ""
              //       } xl:scale-[1.2] 3xl-plus:scale-[1.3]`
              // }`}
              className={`h-full object-contain object-bottom  ${
                readmore ? "" : customCss
              }`}
            />
            <div
              className={`absolute bottom-[10%] xl:bottom-0 3xl-plus:bottom-[5%]  3xl-plus:-left-[20%] ${
                readmore ? "" : "xl:-left-[10%]"
              }`}
            >
              <h2 className="uppercase text-left w-full text-[60px] leading-[60px] 3xl-plus:text-[80px] 3xl-plus:leading-[80px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
                {founder?.firstName} <br /> {founder?.lastName}
              </h2>
              <p className="font-montserrat text-white font-normal text-[12px] md:text-[18px] 2xl-plus::text-[18px] uppercase">
                {`( ${founder?.designation} )`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FounderPersonNew;
